import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsAccordionTriggerIcon = function (props) {
    var accordionConfig = props.accordionConfig, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-accordion-trigger-icon", { ref: ref, "accordion-config": accordionConfig ? (typeof accordionConfig === "string" ? accordionConfig : JSON.stringify(accordionConfig)) : undefined }, children));
};
export default VeltNotificationsPanelSettingsAccordionTriggerIcon;
